import Auth from "./Auth";

class Users {
  static getUsers(type, role, brandId = null, sort = 'first_name,last_name'){
    if(type && role){
      return Auth.makePrivateGet(`${BASE_URL}api/users?page=1&page_size=1000&sort=${sort}&filter[type]=${type}&filter[role]=${role}${(brandId!=null?`&filter[brand_ids]=${brandId}`:``)}`);
    }
    return console.warning('Missing user type and role parameter');
  }

  static getUsersWhere(filters) {
    const query = Object.keys(filters)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(filters[k]))
      .join('&');
    return Auth.makePrivateGet(`${BASE_URL}api/users?${query}`);
  }

  static getSalesExecutives()
  {
    return Auth.makePrivateGet(`${BASE_URL}api/users/sales-executives`);
  }
  static getExternalSellers(filters)
  {
    const query = Object.keys(filters)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(filters[k]))
      .join('&');
    return Auth.makePrivateGet(`${BASE_URL}api/users/external-sellers?${query}`);
  }
  static exportSalesPartnerCSV( params = false ){
    var queryString = Object.keys(params)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
      .join('&');
      return Auth.makePrivateBlobGet(`${BASE_URL}api/users/external-sellers/export?${queryString}`)
  }
  static getProfile()
  {
    return Auth.makePrivateGet(`${BASE_URL}api/profile/me`);
  }
  static setProfile(payload)
  {
    return Auth.makePrivatePut(`${BASE_URL}api/profile/me`, payload);
  }
  static setProfileFiles(payload)
  {
    return Auth.makePrivateFormDataPost(`${BASE_URL}api/profile/me/files`, payload);
  }
  static createExternalSellerFile(payload)
  {
    return Auth.makePrivatePost(`${BASE_URL}api/profile/me/files/external-seller`, payload);
  }
  static requestValidation()
  {
    return Auth.makePrivatePost(`${BASE_URL}api/profile/me/request-validation`);
  }
  static activateAccount(payload)
  {
    return Auth.makePrivatePost(`${BASE_URL}api/auth/register-welcome`, payload);
  }  
}

export default Users;
